import { useCallback, useEffect } from 'react'
import injectSheet from 'react-jss'
import SelectField from '@/components/SelectField'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import actions from '@/actions'
import style from './style'

const StoreLocatorFilter = ({ classes }) => {
  /*------------------------------
  Redux Connect
  ------------------------------*/
  const { categories, filters, strings } = useSelector((state) => ({
    categories: state.page.taxonomies._cta_store_category || [], // eslint-disable-line
    filters: state.stores.filters,
    strings: state.language.string,
  }), shallowEqual)

  /*------------------------------
  Redux Actions
  ------------------------------*/
  const dispatch = useDispatch()
  const setFilters = useCallback((data) => dispatch(actions.stores.setFilters(data)), [dispatch])

  useEffect(() => {
    return () => {
      setFilters('')
    }
  }, [])

  return categories.length > 0 && (
    <div className={classes.root}>
      <SelectField
        className={classes.select}
        label={strings.filter_placeholder}
        name="ChooseCategory"
        value={filters && categories.find((c) => c.id === filters).name}
        options={[
          { id: '', name: strings.filter_placeholder },
          ...categories.map((category) => ({ id: category.id, name: category.name, slug: category.slug })),
        ]}
        setFieldValue={(label, value) => {
          setFilters(value)
        }}
      />
    </div>
  )
}

export default injectSheet(style)(StoreLocatorFilter)
